import React from 'react';

/**
 * Skeleton 컴포넌트 모음
 * 로딩 중 "불러오는 중..." 텍스트 대신 레이아웃 시프트를 줄이는 스켈레톤 UI를 제공한다.
 */

// 기본 블록 스켈레톤
export const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse rounded bg-accent-100 ${className}`} aria-hidden="true" />
);

// 카드형 스켈레톤 (목록 카드용)
export const CardSkeleton = ({ withImage = true, className = '' }) => (
  <div className={`rounded-lg border border-accent-200 bg-white p-4 ${className}`} aria-hidden="true">
    {withImage && <Skeleton className="mb-4 h-40 w-full" />}
    <Skeleton className="mb-2 h-5 w-3/4" />
    <Skeleton className="mb-2 h-4 w-1/2" />
    <Skeleton className="h-4 w-2/3" />
  </div>
);

// 카드 그리드 스켈레톤
export const CardGridSkeleton = ({ count = 6, columns = 3, withImage = true }) => {
  const colClass =
    {
      2: 'sm:grid-cols-2',
      3: 'sm:grid-cols-2 lg:grid-cols-3',
      4: 'sm:grid-cols-2 lg:grid-cols-4',
    }[columns] || 'sm:grid-cols-2 lg:grid-cols-3';

  return (
    <div className={`grid grid-cols-1 gap-4 ${colClass}`} aria-busy="true" aria-label="불러오는 중">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} withImage={withImage} />
      ))}
    </div>
  );
};

// 테이블 행 스켈레톤 (관리자 DataTable 등)
export const TableSkeleton = ({ rows = 5, columns = 5 }) => (
  <div className="w-full" aria-busy="true" aria-label="불러오는 중">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-4 border-b border-accent-100 px-4 py-3">
        {Array.from({ length: columns }).map((_, c) => (
          <Skeleton key={c} className="h-4 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

// 리스트 항목 스켈레톤
export const ListSkeleton = ({ rows = 4 }) => (
  <div className="space-y-3" aria-busy="true" aria-label="불러오는 중">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="rounded-lg border border-accent-200 bg-white p-4">
        <Skeleton className="mb-2 h-5 w-1/3" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    ))}
  </div>
);

export default Skeleton;
